import C from "classnames";

const RadioGroup = ({ name, options, value, onChange }) => (
  <div className={C("form__radio")}>
    <div role="group" className={"form__radio-group"}>
      {options.map((option) => {
        return (
          <label key={option.value} className={"form__radio-option"}>
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={value === option.value}
              onChange={(e) => {
                onChange(e.target.value);
              }}
            />
            <span className={"form__radio-label"}>{option.label}</span>
            <span className={"form__radio-checkmark"} />
          </label>
        );
      })}
    </div>
  </div>
);

export { RadioGroup };
